var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',{staticClass:"display-inline"},[_vm._v("Test")]),_c('div',{staticClass:"display-inline ml-3"},[_c('ActiveApiCalls')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }